import { Link as ReactLink } from 'react-router-dom';
import { Box, Button, ButtonBase, Stack, useTheme } from '@mui/material';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export const BANNER_HEIGHT = 45;

interface Props {
  isVisible: boolean;
  children: React.ReactNode;
  action?: { onClick: () => void | Promise<void> } | { href: string };
  hideBanner: () => void;
}

function Banner({ isVisible, children, action, hideBanner }: Props) {
  const theme = useTheme();

  if (!isVisible) return null;

  const isLink = action && 'href' in action;
  const isButton = action && 'onClick' in action;
  const hasAction = isLink || isButton;

  const Component = isLink ? ReactLink : isButton ? ButtonBase : Box;

  return (
    <Box
      bgcolor={theme.palette.primary.main}
      width="100vw"
      height={BANNER_HEIGHT}
      display="flex"
      justifyContent="center"
      alignItems="center">
      <Box
        component={Component}
        to={isLink ? action.href : undefined}
        onClick={isButton ? action.onClick : undefined}
        sx={{
          textDecoration: 'none',
        }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            color="white">
            {children}
          </Stack>
          {hasAction && (
            <EastRoundedIcon sx={{ color: 'common.white' }} fontSize="small" />
          )}
        </Stack>
      </Box>
      <Button
        onClick={hideBanner}
        sx={{
          position: 'absolute',
          right: '10px',
          display: 'flex',
          alignItems: 'center',
        }}>
        <CloseRoundedIcon sx={{ color: 'common.white' }} fontSize="small" />
      </Button>
    </Box>
  );
}

export default Banner;
